import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Determined Derelicts',
  date: new Date(2023, 8, 3),
  img: '/img/badger.jpeg',
  tracks: [
    {
      title: 'Please Stand By',
      src: '/songs/2023-09-03/please_stand_by.mp3',
    },
    {
      title: 'Blues Boys',
      src: '/songs/2023-09-03/blues_boys.mp3',
    },
    {
      title: 'Unwind Myself Again',
      src: '/songs/2023-09-03/unwind_myself_again.mp3',
    },
    {
      title: 'Two Girls in a Lonely Bar',
      src: '/songs/2023-09-03/two_girls_in_a_lonely_bar.mp3',
    },
    {
      title: 'Crossing the Stream',
      src: '/songs/2023-09-03/crossing_the_stream.mp3',
    },
    {
      title: 'Getting Caught Up',
      src: '/songs/2023-09-03/getting_caught_up.mp3',
    },
    {
      title: 'Lean On Me',
      src: '/songs/2023-09-03/lean_on_me.mp3',
    },
    {
      title: 'Hold on to your Seat',
      src: '/songs/2023-09-03/hold_on_to_your_seat.mp3',
    },
    {
      title: 'Rabid Honey Badger',
      src: '/songs/2023-09-03/rabid_honey_badger.mp3',
    },
    {
      title: 'Shakunta La',
      src: '/songs/2023-09-03/shakunta_la.mp3',
    },
    {
      title: 'Don\'t know Nothin bout no Money',
      src: '/songs/2023-09-03/dont_know_nuthin_bout_no_money.mp3',
    },
    {
      title: 'Have you heard the News',
      src: '/songs/2023-09-03/have_you_heard_the_news.mp3',
    },
    {
      title: 'Rise up from the Ocean',
      src: '/songs/2023-09-03/rise_up_from_the_ocean.mp3',
    },
    {
      title: 'Ollie Nanitokki and Brian',
      src: '/songs/2023-09-03/ollie_nanitokki_and_brian.mp3',
    },
    {
      title: 'Homer\'s Odyssey Revisited',
      src: '/songs/2023-09-03/homers_odyssey_revisited.mp3',
    },
    {
      title: 'Silky Smooth Hair Plugs',
      src: '/songs/2023-09-03/silky_smooth_hair_plugs.mp3',
    },
    {
      title: 'Time - It\'s not your Friend',
      src: '/songs/2023-09-03/time_its_not_your_friend.mp3',
    },
  ]
}
export default album;